import { render, staticRenderFns } from "./LiveChatMp4V2Tree.vue?vue&type=template&id=3f47b93f&scoped=true&"
import script from "./LiveChatMp4V2Tree.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4V2Tree.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4V2Tree.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiveChatMp4V2Tree.vue?vue&type=style&index=1&id=3f47b93f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47b93f",
  null
  
)

export default component.exports